import {
  ADD_COMPLAINT_QUESTION,
  ADD_COMPLAINT_QUESTION_FAIL,
  ADD_COMPLAINT_QUESTION_SUCCESS,
  ARRANGE_COMPLAINT_QUES_ORDER_FAIL,
  ARRANGE_COMPLAINT_QUES_ORDER_SUCCESS,
  DELETE_COMPLAINT_QUESTION_FAIL,
  DELETE_COMPLAINT_QUESTION_SUCCESS,
  EDIT_COMPLAINT_QUESTION_FAIL,
  EDIT_COMPLAINT_QUESTION_SUCCESS,
  GET_ADDED_COMPLAINT_QUESTION_FAIL,
  GET_ADDED_COMPLAINT_QUESTION_SUCCESS,
  GET_COMPLAINT_REGISTER_FAIL,
  GET_COMPLAINT_REGISTER_SUCCESS,
  REVIEW_COMPAINT_FORM_FAIL,
  REVIEW_COMPAINT_FORM_SUCCESS,
  GET_COMPLAINT_FORM_FAIL,
  GET_COMPLAINT_FORM_SUCCESS,
  GET_COMPLAINT_FORM_PREVIEW_FAIL,
  GET_COMPLAINT_FORM_PREVIEW_SUCCESS,
} from "./actionTypes";

const STATE_INIT = {
  res: [],
  error: [],
  list: [],
  addedQuestions: [],
};

const ComplaintRegister = (state = STATE_INIT, action) => {
  switch (action.type) {
    case ADD_COMPLAINT_QUESTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_COMPLAINT_QUESTION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case GET_ADDED_COMPLAINT_QUESTION_SUCCESS:
      return {
        ...state,
        addedQuestions: action.payload,
      };
    case GET_ADDED_COMPLAINT_QUESTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_COMPLAINT_QUESTION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_COMPLAINT_QUESTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case EDIT_COMPLAINT_QUESTION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case EDIT_COMPLAINT_QUESTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ARRANGE_COMPLAINT_QUES_ORDER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };

    case ARRANGE_COMPLAINT_QUES_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_COMPLAINT_REGISTER_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_COMPLAINT_REGISTER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_COMPLAINT_FORM_SUCCESS:
      return {
        ...state,
        addedQuestions: action.payload,
      };
    case GET_COMPLAINT_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_COMPLAINT_FORM_PREVIEW_SUCCESS:
      return {
        ...state,
        addedQuestions: action.payload,
      };

    case GET_COMPLAINT_FORM_PREVIEW_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REVIEW_COMPAINT_FORM_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case REVIEW_COMPAINT_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};
export default ComplaintRegister;
